import { PhaseTypeEnum } from '@vatos-pas/common';

/**
 * Centralized priority to phase type mappings
 * This ensures consistency across all components and prevents mapping bugs
 */

export const DRYWALL_PRIORITY_MAP: { [key: number]: PhaseTypeEnum } = {
  200: PhaseTypeEnum.Garage,
  300: PhaseTypeEnum.Hanging,
  400: PhaseTypeEnum.Finishing,
  500: PhaseTypeEnum.Spraying,
  600: PhaseTypeEnum.Bump1,
  700: PhaseTypeEnum.Bump2,
  800: PhaseTypeEnum.Bump3,
  900: PhaseTypeEnum.Bump4,
  1000: PhaseTypeEnum.Bump5,
};

export const DRYWALL_AND_PAINT_PRIORITY_MAP: { [key: number]: PhaseTypeEnum } = {
  200: PhaseTypeEnum.Garage,
  300: PhaseTypeEnum.Hang,
  400: PhaseTypeEnum.Finish,
  500: PhaseTypeEnum.Prime,
  600: PhaseTypeEnum.Trim1,
  700: PhaseTypeEnum.DrywallTouchUp1,
  800: PhaseTypeEnum.InteriorPaint,
  900: PhaseTypeEnum.Trim2,
  1000: PhaseTypeEnum.DrywallTouchUp2,
  1100: PhaseTypeEnum.FinalPaint,
  1200: PhaseTypeEnum.DrywallTouchUp3,
  1300: PhaseTypeEnum.CMBluetape,
  1400: PhaseTypeEnum.FinalBluetape,
};

/**
 * Get phase type from priority based on job phase structure type
 * @param priority - Job phase priority
 * @param phaseStructureType - Job phase structure type ('Drywall' or 'DrywallAndPaint')
 * @returns PhaseTypeEnum or null if not found
 */
export const getPhaseTypeFromPriority = (
  priority: number,
  phaseStructureType?: string,
): PhaseTypeEnum | null => {
  const isDrywall = !phaseStructureType || phaseStructureType === 'Drywall';
  
  if (isDrywall) {
    return DRYWALL_PRIORITY_MAP[priority] || null;
  } else {
    return DRYWALL_AND_PAINT_PRIORITY_MAP[priority] || null;
  }
};

/**
 * Get DrywallAndPaint phase type from priority (simplified for components that only work with DrywallAndPaint)
 * @param priority - Job phase priority
 * @returns PhaseTypeEnum or null if not found
 */
export const getDrywallAndPaintPhaseTypeFromPriority = (
  priority: number,
): PhaseTypeEnum | null => {
  return DRYWALL_AND_PAINT_PRIORITY_MAP[priority] || null;
};